import dayjs from "dayjs";

// 平均每月天數（400 年曆法週期的平均），把實際涵蓋天數換算成「有效月數」
const AVERAGE_DAYS_PER_MONTH = 30.4375;

// 計算所選區間涵蓋的天數與有效月數，作為平均值統計的分母。
// 語意需與 server 的 monthWindow 一致：預設區間為「含當月在內的最近 N 個月」。
// monthCount 以「實際天數 / 平均每月天數」計算（可為小數）：
// 用日曆月份數當分母會失真 — 自訂 1/10~3/5（55 天）會被當成 3 個月而低估月均 40%，
// 月中查看「近 N 個月」時，當月只過了一半也會被算成完整一個月。
export function rangeMetrics({ months, startDate, endDate }) {
  // 自訂範圍的起訖可能顛倒（跟 server 的 dateWindow.dateRangeWindow 一樣需要先對調），
  // 否則 dayCount 會變成負數，讓下面的平均值被 guard 靜默歸零。
  const [earlier, later] =
    !months && dayjs(startDate).isAfter(dayjs(endDate))
      ? [endDate, startDate]
      : [startDate, endDate];

  const start = months
    ? dayjs()
        .subtract(months - 1, "month")
        .startOf("month")
    : dayjs(earlier);
  const end = months ? dayjs() : dayjs(later);

  const dayCount = end.diff(start, "day") + 1;

  return {
    dayCount,
    monthCount: dayCount / AVERAGE_DAYS_PER_MONTH,
  };
}

// 依幣別加總支出列的金額與筆數，算出每幣別的月均/日均支出與支出筆數。
// 只採計支出（type !== "income"），避免收入拉高平均值造成誤導。
export function computeAverageStats(noteSpending, { dayCount, monthCount }) {
  const rows = (noteSpending || []).filter((row) => row.type !== "income");
  const byCurrency = new Map();

  rows.forEach((row) => {
    const key = row.currency.id;
    const existing = byCurrency.get(key) || {
      currency: row.currency,
      total: 0,
      count: 0,
    };
    existing.total += row.total;
    existing.count += row.count;
    byCurrency.set(key, existing);
  });

  return Array.from(byCurrency.values()).map(({ currency, total, count }) => ({
    currency,
    monthlyAvgExpense: monthCount > 0 ? total / monthCount : 0,
    dailyAvgExpense: dayCount > 0 ? total / dayCount : 0,
    transactionCount: count,
  }));
}
